import config from "../../../config/app";

export const createSessionToken = () =>
  new Promise((resolve, reject) => {
    const fetchConfig = { method: "POST" };
    fetch(config.graphql.tokenService, fetchConfig)
      .then(response => response.json())
      .catch(reject)
      .then(({ token }) => resolve(token));
  });
